module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 14-67adecc7b4b44574664c8899429b7ab1.jpg";